import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#A8ACBD",
  d: "M3 8.967c0 1.665 1.32 3.015 2.948 3.015h1.407L8.53 8.807h3.57l-.817 2.404h2.216l-.529.771h1.488c1.404 0 2.542-1.164 2.542-2.6 0-1.436-1.138-2.6-2.542-2.6-.149 0-.293.016-.435.04-.227-1.907-1.816-3.384-3.742-3.384h-.038l-.037.003c-1.626.032-3 1.116-3.497 2.616a2.89 2.89 0 0 0-.76-.105C4.32 5.952 3 7.302 3 8.967Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0A000",
  fillRule: "evenodd",
  d: "M8.974 9.403h2.24l-.84 2.417h1.96l-3.36 4.742.653-3.423h-1.96l1.307-3.736Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=StormIcon20.js.map